import React, {Component} from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';

import {FormGroup, Checkbox} from 'react-bootstrap';

/** Component to render a checkbox */
class SpogCheckbox extends Component {

    static propTypes = {
        name:      PropTypes.string, // The name of the input field
        bsSize:    PropTypes.string, // The bootstrap based size
        label:     PropTypes.string, //The text to show in the label
        value:     PropTypes.bool, // The value of the checkbox
        autoFocus: PropTypes.bool, //True when the input should be autofocusable
        onChange:  PropTypes.func, // Listener when the value has changed
        disabled:  PropTypes.bool // True when the input should be disabled
    };
    static defaultProps = {
        name:      '',
        bsSize:    'lg',
        label:     '',
        value:     false,
        autoFocus: false,
        disabled:  false
    };

    /**
     * Set this to listeners
     */
    componentWillMount() {
        this.handleChange = this.handleChange.bind(this);
    }

    /**
     * Do the autofocus
     */
    componentDidMount() {
        const {autoFocus} = this.props;

        autoFocus && ReactDOM.findDOMNode(this.refs.input).focus();
    }

    /**
     * Handle when the checkbox has changed
     * @param {Event} e The event object
     */
    handleChange(e) {
        const {onChange} = this.props;

        onChange && onChange(e.currentTarget.checked);
    }

    render() {
        const {
            name,
            bsSize,
            label,
            value,
            disabled
        } = this.props;

        return (
            <FormGroup bsSize={bsSize}>
                <Checkbox
                    ref="remember"
                    name={name}
                    checked={value}
                    onChange={this.handleChange}
                    disabled={disabled}
                >
                    {label}
                </Checkbox>
            </FormGroup>
        );
    }
}

export default SpogCheckbox;



// WEBPACK FOOTER //
// ./src/components/ui/form/SpogCheckbox.jsx